<div class="you-chat p-0" [ngClass]="{'stickyStyle': fromSticky}">
  <div class="you-chat-sidebar" [ngClass]="{'stickyStyle': fromSticky}" *ngIf="showSidebar">
    <div class="you-chat-sidebar-controls" *ngIf="!fromSticky">
      <div *ngIf="!showYouChatSettings" class="show-settings">
        <i class="iconfont iconshezhi mr-3" (click)="openYouChatSettings()"></i>
      </div>
      <div *ngIf="showYouChatSettings">
        <div class="" (click)="closeYouChatSettings()" class="show-contacts">
          <i class="iconfont iconjiantou_liebiaoxiangzuo mr-3" (click)="openYouChatSettings()"></i>
          <div>
            消息设置
          </div>
        </div>
      </div>
    </div>
    <div class="you-chat-sidebar-controls stickyStyle justify-content-center" style="border-right: none;"
      *ngIf="fromSticky">
      私信(<span class="notranslate">{{ contactsNums }}</span>)
    </div>
    <div style="height: calc(100% - 38px);">
      <div *ngIf="showYouChatSettings">
        <div class="you-chat-settings-item">
          <div>只接受互关好友私信</div>
          <app-slide-toggle style="margin-right: 5px;" [status]="(settings$ | async)?.friendOnly"
            (changed)="toggleMessageFriedOnly()">
          </app-slide-toggle>
        </div>
      </div>
      <you-chat-sidebar [selectedUser]="selectedUser" (onSelectUser)="onSelectUser($event)" [fromSticky]="fromSticky"
        (onRemoveUser)="onRemoveUser($event)" *ngIf="!showYouChatSettings">
      </you-chat-sidebar>
    </div>
  </div>
  <app-chat-container style="flex: 1; height: 100%; position: relative">
    <div class="you-chat-content-controls" [ngClass]="{'stickyStyle': fromSticky}">
      <div class="you-chat-content-controls-title" [ngClass]="{'stickyStyle': fromSticky}" (click)="navToUserPage()">
        <div *ngIf="selectedUser?.isOfficalSpeaker" class="you-chat-content-controls-title__avatar-vip mr-2"
          [ngClass]="{'stickyStyle': fromSticky}">
          <!-- <img class="vip-icon-path" src="{{'./assets/images/officalSpeaker.png' | absUrl}}"> -->
          <app-membership-icon class="new-speaker-icon"
            [membership]="'speaker'"
            [noText]="true" [newIcon]="true">
          </app-membership-icon>
        </div>
        {{selectedUser?.name}}
        <button class="follow-button ml-2" (click)="changeFollowStatus()" *ngIf="!!selectedUser && !fromSticky"
          [ngClass]="{followed: selectedUser?.followStatus === 'Followed', 'not-followed': selectedUser?.followStatus ===
          'NotFollowed', 'biway-followed': selectedUser?.followStatus === 'BiWayFollowed'}">{{
          selectedUser?.followStatus === 'Followed' ? '已关注'
          : selectedUser?.followStatus === 'NotFollowed' ? '关注'
          : selectedUser?.followStatus === 'BiWayFollowed' ? '互相关注' : '关注'
          }}</button>
      </div>
      <div class="ml-auto" #chatMenuElem *ngIf="!fromSticky">
        <i class="iconfont iconshezhi mr-3" (click)="toggleChatMenu()"></i>
        <div class="chat-menu" *ngIf="showChatMenu">
          <div (click)="addToBlackList()" *ngIf="!(isUserBlocked$ | async)">加入黑名单</div>
          <div (click)="clearHistory()">清空聊天记录</div>
          <div (click)="reportUser()">举报用户</div>
        </div>
      </div>
      <!-- <div class="mr-auto" #chatMenuElem *ngIf="fromSticky">
        <i class="iconfont iconshezhi" (click)="toggleChatMenu()"></i>
        <div class="chat-menu" *ngIf="showChatMenu">
          <div (click)="addToBlackList()">加入黑名单</div>
          <div (click)="clearHistory()">清空聊天记录</div>
          <div (click)="reportUser()">举报用户</div>
        </div>
      </div> -->
      <div class="ml-auto d-flex align-items-center" *ngIf="fromSticky">
        <i class="iconfont iconTZ sticky-navTo" (click)="navToPage()"></i>
        <i class="iconfont iconguanbi sticky-close" (click)="closeChatLog()"></i>
      </div>
    </div>
    <div class="chat-container" [ngClass]="{'stickyStyle': fromSticky}">
      <div style="flex: 0 1 auto; overflow: hidden;" class="you-chat-log" [ngClass]="{'stickyStyle': fromSticky}">
        <div class="scroll-bar transparent" style="height: 100%;overflow-y: overlay;overflow-x: hidden;" #youChatLog
          scrollEvent (onScrollStart)="onReachStart()" (onScrollEnd)="onReachEnd()" (onScrollUp)="onScrollUp()"
          [ngClass]="{'dirty':loading}"
          >
          <div *ngIf="loading" class="loading-previous-messages">
            <app-loading></app-loading>
          </div>
          <app-you-chat-log [messages]="socketFacade.selectCurrentMessagesGroupByDateTime$ | async" [currentUser]="user"
            (onChanged)="onChanges()" (onOpenViewer)="openPictureViewer($event)" [fromSticky]="fromSticky"
            [isUserBlocked]="isUserBlocked$ | async">
          </app-you-chat-log>
          <div class="unread-messages" *ngIf="unreadMessages.length" (click)="scrollToBottom()">下方有新的消息</div>
        </div>
      </div>
      <div class="you-chat-input" style="flex: 0 0 auto;" *ngIf="!!selectedUser">
        <div class="you-chat-input-containter" [ngClass]="{'stickyStyle': fromSticky}">
          <div class="d-flex align-items-center" [ngClass]="fromSticky ? 'mb-1': 'mb-2'">
            <div #emojiPickerElem>
              <icon-button (onClick)="toggleEmojiBox()">
                <span class="iconfont iconbiaoqing"></span>
              </icon-button>
              <app-emoji-box *ngIf="showEmojiBox"></app-emoji-box>
            </div>
            <div>
              <input hidden type="file" accept="image/jpeg,image/png,.jpeg,.jpg,.png" #imageInput
                (change)="onImageChange($event)" />
              <icon-button (onClick)="addImage()">
                <span class="iconfont icontupian2"></span>
              </icon-button>
            </div>
          </div>
          <contenteditable [placeholder]="'说点啥吧~'" (ValueChangedEvent)="onInputChange($event)"
            (scrollEndEvent)="scrollToBottom()" (SendEvent)="sendMessage()" #contenteditable
            [clearEditorFlag]="clearEditorFlag" (onClearedEvent)="resetFlag()">
          </contenteditable>
        </div>

        <div class="you-chat-input-controls d-flex justify-content-end" [ngClass]="{'stickyStyle': fromSticky}"
          (click)="focusInEditor()">
          <app-dn-button (onClick)="onSendButtonClick($event)">发送</app-dn-button>
        </div>
      </div>

      <div *ngIf="loadingMessages$ | async" class="loading-messages">
        <app-loading></app-loading>
      </div>
    </div>
  </app-chat-container>
  <div *ngIf="loadingContacts$ | async" class="loading-messages">
    <app-loading></app-loading>
  </div>
  <!-- <div *ngIf="loadingContacts$ | async" class="loading-messages chat-dev" [ngClass]="isDark === true ? 'dark' : 'light'">
  </div> -->
  <div *ngIf="noHistory$ | async" class="loading-messages">
    没有活跃的联系人
  </div>
</div>

<dn-dialog style="position:relative" id="report-chat" class="dn-dialog-background">
  <ng-template let-data="data">
    <div class="mt-1 title">请选择举报原因</div>
    <div class="mt-2 mb-3"></div>
    <div class="reasons">
      <div *ngFor="let item of reportReasons" class="reason">
        <label class="rad mb-3">
          <input type="radio" name="report-reasons" [value]="item.id" [(ngModel)]="reportReason">
          <i></i> {{item.name}}
        </label>
      </div>
    </div>
    <div>
      <div class="mt-2 mb-3">备注：</div>
      <div>
        <form [formGroup]="reportForm">
          <textarea formControlName="description" name="" id="" rows=" 3" maxlength="100"
            placeholder="请输入举报原因"></textarea>
        </form>
      </div>
    </div>
    <app-dn-dialog-close-button [dialog]="'report-chat'"></app-dn-dialog-close-button>
    <!-- <div class="dn-dialog-buttons">
      <a class="dn-button" (click)="report()">举报</a>
    </div> -->
    <div class="d-flex justify-content-center mt-3">
      <app-dn-button (click)="report()">提交</app-dn-button>
    </div>
  </ng-template>
</dn-dialog>

<dn-dialog id="confirm-dialog-inComponent" class="dn-dialog-background">
  <ng-template let-data="data">
    <app-confirm-dialog></app-confirm-dialog>
    <app-dn-dialog-close-button [dialog]="'confirm-dialog-inComponent'"></app-dn-dialog-close-button>
  </ng-template>
</dn-dialog>

<dn-dialog id="message-dialog-inComponent" class="dn-dialog-background">
  <ng-template let-data="data">
    <app-message-dialog [message]="data.message"></app-message-dialog>
    <div class="dn-dialog-buttons">
      <app-dn-dialog-button [buttonText]="data.buttonText || '确定'" [dialog]="'message-dialog-inComponent'">
      </app-dn-dialog-button>
    </div>
    <app-dn-dialog-close-button [dialog]="'message-dialog-inComponent'"></app-dn-dialog-close-button>
  </ng-template>
</dn-dialog>